import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageCreateAudioPage } from './message-create-audio';
import { ComponentsModule } from '../../components/components.module';
import { RoundProgressModule } from 'angular-svg-round-progressbar';

@NgModule({
	declarations: [
		MessageCreateAudioPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(MessageCreateAudioPage),
		RoundProgressModule,
	],
})
export class MessageCreateAudioPageModule { }



// WEBPACK FOOTER //
// ./src/pages/message-create-audio/message-create-audio.module.ts